module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-27.6e45de95.jpg";